import React from "react";

/**
 * "GOOD [+O] · for your vision. for your style. for the planet."
 * Uses the compact "GOOD" mark from the packaging PDF (top half of the
 * full Good Eyes logo). Renders the mark alongside the 3-line tagline.
 */
export const GoodTagline = ({
  className = "",
  variant = "black",
  height = 50,
  accentColor,
  size = "md",
}) => {
  const accent = accentColor || (variant === "white" ? "#F2B41C" : "#C7332A");
  const src = variant === "white" ? "/assets/logo-good-white.png" : "/assets/logo-good.png";
  const width = height * (1057 / 246);

  const textSize =
    size === "sm" ? "text-[11px] md:text-xs" :
    size === "lg" ? "text-sm md:text-lg" : "text-xs md:text-sm";

  return (
    <div className={`inline-flex items-center gap-4 md:gap-5 ${className}`}>
      <img
        src={src}
        alt="Good"
        style={{ height, width }}
      />
      <div
        className={`${textSize} font-semibold leading-[1.15] tracking-tight`}
        style={{
          color: variant === "white" ? "#F4EBD9" : "#001F5B",
          fontFamily: "Manrope, sans-serif",
        }}
      >
        <div>for your vision.</div>
        <div>for your style.</div>
        <div style={{ color: accent }}>for the planet.</div>
      </div>
    </div>
  );
};

export default GoodTagline;
